<style lang="scss">
.el-cascader-menu {
	height: 300px;
	min-width: 500px;
}
</style>
<style lang="scss" scoped>
@include component(component) {
	@include part(loading) {
		color: lighten(black, 50);
	}
}
</style>

<template>
  <div class="component">
    <el-cascader
      v-model="value"
      @change="change"
      clearable
	  style="width: 100%"
      v-if="!$apollo.loading"
      :options="options"
      :props="{ label: 'name', value: 'org_unit_id', children: 'children' }"
      change-on-select
    ></el-cascader>
    <div class="component__loading" v-else>
      <i class="el-icon-loading"></i> Loading organisations...
    </div>
  </div>
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
export default {
	props: ["value"],

	apollo: {
		organisations: {
			query: gql`
				{
					Organisations {
						id
						parent_id
						name,
						org_unit_id
					}
				}
			`,
			update: r => r.Organisations
		}
	},

	data() {
		return {
			organisations: null
		};
	},

	methods: {
		change(value) {
			this.$emit("input", this.value);
		}
	},

	computed: {
		options() {
			if (this.organisations) {
				const ous = _.cloneDeep(this.organisations);

				const descend = outerOu => {
					const children = _.remove(ous, innerOu => innerOu.parent_id === outerOu.id);
					if (children.length) outerOu.children = _.map(children, descend);

					return outerOu;
				};

				// Get root element(s) and build heirarchy for each
				const roots = _.remove(ous, ou => !ou.parent_id);
				return _.map(roots, descend);
			} else {
				return [];
			}
		}
	}
};
</script>

